import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetPolicies = (params, signal) => axios.get(apiPaths.policiesBase, { params, signal });

const onExportPolicies = (policiesIds) =>
  axios.post(`${apiPaths.policiesBase}/create-export-file`, policiesIds, { responseType: 'arraybuffer' });

export { onGetPolicies, onExportPolicies };
